import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { NoticeEdit } from './components';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const NoticeInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.notice);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Notice Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Title</TableCell>
              <TableCell>{model.title}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Timestamp</TableCell>
              <TableCell>{moment(model.timestamp).format("DD/MM/YYYY - HH:mm")}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Content</TableCell>
              <TableCell>{model.notice_content.content}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <NoticeEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

NoticeInfo.propTypes = {
  className: PropTypes.string,
};

export default NoticeInfo;
